export function isBlueLabel() {
    return process.env.REACT_APP_BRONSON_BRAND === "bluelabel";
}
